export const filterChipSx = { fontFamily: "Rubik", fontWeight: 500, borderRadius: "10px" };

export const outlinedFilterChipSx = {
  ...filterChipSx,
  height: 24,
  fontSize: "0.8125rem",
  borderColor: "rgba(0, 0, 0, 0.23)",
  "& .MuiChip-label": { px: 1 },
};

export const activePresetChipSx = {
  ...filterChipSx,
  backgroundColor: "#fff",
  color: "#0b3d87",
  borderColor: "#0b3d87",
  height: 24,
  "&:hover": { backgroundColor: "#f8fafc" },
};

export const periodSelectChipSx = {
  ...filterChipSx,
  color: "#fff",
  borderColor: "rgba(11, 61, 135, 0.45)",
  backgroundColor: "#0b3d87",
  height: 24,
  "&:hover": {
    backgroundColor: "#0e4ead",
  },
};

export const iconActionChipSx = {
  ...outlinedFilterChipSx,
  cursor: "pointer",
  "& .MuiChip-label": { px: 0.75, display: "flex", alignItems: "center" },
};
